module.exports = __webpack_public_path__ + "img/fang-year0.be4306a6.png";